export default function injectScript(src: string, id?: string) {
  return new Promise<void>(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    if (id) script.id = id;
    script.addEventListener('load', function () {
      resolve();
    });
    script.addEventListener('error', function (e) {
      reject(e);
    });
    document.body.appendChild(script);
  });
}
